import type { ChatStory } from "../types";
import type { GroupedLogs } from "../utils/message-parsers";

import { ChatStoryContent } from "../utils/message-content";

interface MessageListProps {
  currentUserId?: null | number;
  handleOpenPreview: (id: number) => void;
  isCostumer: boolean;
  isLoading: boolean;
  messages: (ChatStory | GroupedLogs)[];
  onEditClick?: (messageId: number, batchId: string) => void;
  onFeedbackClick?: (groupId: string) => void;
  timeZone: null | string;
}

export function MessageList({
  currentUserId,
  handleOpenPreview,
  isCostumer,
  isLoading,
  messages,
  onEditClick,
  onFeedbackClick,
  timeZone,
}: MessageListProps) {
  if (messages.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-text-tertiary text-sm">
        <p>No messages yet</p>
        <p>Start the conversation by sending a message</p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-[20px] ${isLoading ? "pt-16" : ""}`}>
      {messages.map((message, index) => (
        <div key={`${message.id || index}-${message.createdAt || index}`}>
          <ChatStoryContent
            chatStory={message}
            handleOpenPreview={handleOpenPreview}
            isCostumer={isCostumer}
            isCurrentUser={currentUserId === message.user?.id}
            onEditClick={onEditClick}
            onFeedbackClick={onFeedbackClick}
            timeZone={timeZone}
          />
        </div>
      ))}
    </div>
  );
}
